import React, {Component} from 'react';
import LoadingSpinner from "../Utils/LoadingSpinner";

class PartnerAgreements extends Component {
    state = {
        loading: true
    };

    componentDidMount() {
        this.props.simGps.getPartnerAgreements(
            (success, result) => {
                if(success){
                    this.setState({loading:false, agreements: result})
                }else{
                    this.setState({loading:false})
                }
            }
        );
    }

    render() {
        if (this.state.loading) {
            return (<LoadingSpinner text="Retrieving agreements ..."/>);
        } else {
            return (
                this.state.agreements.map( agreement => (
                    <div key={agreement.id}>
                        Name {agreement.name}
                        My share {agreement.percent/ 100.} %
                    </div>
                ) )
            );
        }
    }
}

export default PartnerAgreements;
